var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtsdatabankenSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.93 566.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#e55440;}.d{fill:#262f31;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 482.55 482.55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M241.27,482.55C108.24,482.55,0,374.32,0,241.27S108.24,0,241.27,0s241.28,108.24,241.28,241.27h-60.9c0-99.45-80.91-180.37-180.37-180.37S60.9,141.82,60.9,241.27s80.91,180.38,180.37,180.38v60.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "482.55 482.55 317.02 482.55 317.02 422.23 422.23 422.23 422.23 317.02 482.55 317.02 482.55 482.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 309.31,
    cy: 241.28,
    r: 37.87
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 482.55,
    height: 482.55,
    transform: "translate(142.68 139.88) scale(.53)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtsdatabankenSymbol);
export default __webpack_public_path__ + "static/media/ArtsdatabankenSymbol.d4546c118b6aa0d1dfe8132d04836ee4.svg";
export { ForwardRef as ReactComponent };